import { Record } from "immutable"

export const schema = {
  simulation: false,
  simulationSpeed: 0,
}

export default Record(schema)



// WEBPACK FOOTER //
// ./src/models/simulations.model.js